'use strict';

const Config = function($httpProvider) {
    'ngInject';
    
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // Answer edited to include suggestions from comments
    // because previous version of code introduced browser-related errors

    // //disable IE ajax request caching
    // $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'private, no-cache, no-store, must-revalidate';
    $httpProvider.defaults.headers.get.Pragma = 'no-cache';
};

export default Config;


// WEBPACK FOOTER //
// ./src/app/common/core/services/data/data.config.js